export enum MinimalScheduleFrequency {
  ONCE = 'ONCE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export const MinimalScheduleFrequencyTranslation = {
  [MinimalScheduleFrequency.ONCE]: 'enum.minimalScheduleFrequency.once',
  [MinimalScheduleFrequency.DAILY]: 'enum.minimalScheduleFrequency.daily',
  [MinimalScheduleFrequency.WEEKLY]: 'enum.minimalScheduleFrequency.weekly',
  [MinimalScheduleFrequency.MONTHLY]: 'enum.minimalScheduleFrequency.monthly',
  [MinimalScheduleFrequency.YEARLY]: 'enum.minimalScheduleFrequency.yearly'
};
